module.exports = __webpack_public_path__ + "static/media/bestHospitals.38397c04.webp";